import React, { memo, HTMLProps, useState } from "react";
import classnames from "classnames";
import { PLACE_HOLDER } from "src/constants";
import { ImgUtils, Logger } from "src/utils";
import { Element } from "../base";

interface IProps extends HTMLProps<HTMLImageElement> {
    src: string;
    alt?: string;
    size?: number;
    rounded?: boolean;
    className?: string;
    renderAs?: string;
    children?: React.ReactNode;
}

const Image = React.forwardRef(
    (
        {
            src = "",
            alt = "",
            size,
            rounded,
            className,
            children,
            renderAs = "figure",
            width,
            height,
            ...rest
        }: IProps,
        ref
    ) => {
        const [error, setError] = useState<boolean>(false);
        
        const onError = () => {
            setError(true);
            Logger.errorImage("Error loadImage fail|src:", { src, alt });
        };

        return (
            <Element
                {...rest}
                domRef={ref}
                renderAs={renderAs}
                className={classnames(
                    "image",
                    {
                        "is-rounded": rounded,
                    },
                    className
                )}
            >
                {src && (
                    <picture>
                        <source
                            srcSet={
                                error
                                    ? PLACE_HOLDER.IMAGE
                                    : ImgUtils.convertToAvif(src)
                            }
                            type="image/avif"
                        />
                        <source
                            srcSet={
                                error
                                    ? PLACE_HOLDER.IMAGE
                                    : ImgUtils.convertToWebp(src)
                            }
                            type="image/webp"
                        />
                        <img
                            src={error ? PLACE_HOLDER.IMAGE : src}
                            alt={alt}
                            width={width}
                            height={height}
                            onError={onError}
                        />
                    </picture>
                )}
            </Element>
        );
    }
);

export default memo(Image);
